/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../common/locale';
import '../../resources/warranty_product';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "SearchWarrantyProductsFilter": {
                    "fields": {
                      "merchantToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "serialNumber": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "storeCode": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "SearchWarrantyProductsQuery": {
                    "fields": {
                      "filter": {
                        "type": "squareup.solidshop.v2.service.SearchWarrantyProductsFilter",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "SearchWarrantyProductsRequest": {
                    "fields": {
                      "query": {
                        "type": "squareup.solidshop.v2.service.SearchWarrantyProductsQuery",
                        "id": 1,
                        "rule": "optional"
                      },
                      "locale": {
                        "type": "squareup.solidshop.v2.common.Locale",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": "EN_US"
                        }
                      }
                    }
                  },
                  "SearchWarrantyProductsResponse": {
                    "fields": {
                      "warrantyProducts": {
                        "type": "squareup.solidshop.v2.resources.WarrantyProduct",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "details": {
                        "type": "squareup.solidshop.v2.resources.WarrantyProductDetail",
                        "id": 2,
                        "keyType": "string"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 3,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.SearchWarrantyProductsFilter && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.SearchWarrantyProductsQuery && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.SearchWarrantyProductsRequest && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.SearchWarrantyProductsResponse) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE SearchWarrantyProductsFilter @ squareup/solidshop/v2/service/warranty_products/search_warranty_products.proto at 12:1
 */
export const SearchWarrantyProductsFilter = $root.lookupType('squareup.solidshop.v2.service.SearchWarrantyProductsFilter');
fixType(SearchWarrantyProductsFilter);
Builder.createAndAttachToType(SearchWarrantyProductsFilter);
/**
 * SOURCE SearchWarrantyProductsQuery @ squareup/solidshop/v2/service/warranty_products/search_warranty_products.proto at 23:1
 */
export const SearchWarrantyProductsQuery = $root.lookupType('squareup.solidshop.v2.service.SearchWarrantyProductsQuery');
fixType(SearchWarrantyProductsQuery);
Builder.createAndAttachToType(SearchWarrantyProductsQuery);
/**
 * SOURCE SearchWarrantyProductsRequest @ squareup/solidshop/v2/service/warranty_products/search_warranty_products.proto at 28:1
 */
export const SearchWarrantyProductsRequest = $root.lookupType('squareup.solidshop.v2.service.SearchWarrantyProductsRequest');
fixType(SearchWarrantyProductsRequest);
Builder.createAndAttachToType(SearchWarrantyProductsRequest);
/**
 * SOURCE SearchWarrantyProductsResponse @ squareup/solidshop/v2/service/warranty_products/search_warranty_products.proto at 36:1
 */
export const SearchWarrantyProductsResponse = $root.lookupType('squareup.solidshop.v2.service.SearchWarrantyProductsResponse');
fixType(SearchWarrantyProductsResponse);
Builder.createAndAttachToType(SearchWarrantyProductsResponse);
